import {MarketplaceHeader, HeaderContainer} from '@treatwell/ui';
import styles from './MarketplaceHeader/MarketplaceHeader.module.css';
import {GenericError} from './Error';

export const GenericErrorPage = ({
  children,
}: {
  children?: React.ReactElement;
}) => {
  return (
    <>
      <HeaderContainer>
        <div className={styles.logo}>
          <MarketplaceHeader logoHref="/" />
        </div>
      </HeaderContainer>
      {children ? children : <GenericError />}
    </>
  );
};
